/* global vendorSettings */
import register from 'preact-custom-element'
import { useEffect, useState } from 'preact/hooks'
import { fetchProductsLinked } from 'helpers/fetch'
import ProductCarousel from 'modules/product-carousel/product-carousel'

function ProductVendor() {
  const [isFetching, setIsFetching] = useState(true)

  useEffect(async () => {
    await fetchProductsLinked(products)
    setIsFetching(false)
  }, [])

  return vendorSettings.products.length > 0 && !isFetching && (
    <ProductCarousel
      heading={vendorSettings.heading}
      subheading={vendorSettings.subheading}
      products={vendorSettings.products}
      ctaLink={vendorSettings.ctaLink}
      ctaText={vendorSettings.ctaText}
    />
  )
}

register(ProductVendor, 'product-vendor')
